import React from 'react';
import { FDAlert, FDStack } from '@facet-wealth/design';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';
import ScheduledMeetingDetails
  from 'Packages/FacetDesign/Components/Experimental/ScheduledMeetingDetails/ScheduledMeetingDetails';
import useMobileLayout from 'Hooks/useMobileLayout';

const Layout = () => {
  const { resource } = useMetaLayoutContext();
  const isMobile = useMobileLayout();

  const infoWidth = isMobile ? '100%' : '60%';

  return (
    <FDStack direction="column" spacing={4} paddingY={4} justifyContent={'center'} alignItems={'center'}>
      <FDStack direction="column" justifyContent={'center'} alignItems={'center'} spacing={2} maxWidth={'80%'}>
        <MetaField attr="title" />
        <MetaField attr="subtitle" />
      </FDStack>

      <FDStack direction={'column'} width={infoWidth}>
        <FDAlert description={resource.attr('infoMessage')} />
      </FDStack>

      <ScheduledMeetingDetails
        meetingName={resource.attr('meetingName')}
        meetingStartTime={resource.attr('meetingStartTime')}
        meetingEndTime={resource.attr('meetingEndTime')}
        meetingDuration={resource.attr('meetingDuration')}
        agentProfileImageLink={resource.relationship(fr.relationships.agentProfileImage.name)}
      />

    </FDStack>
  );
};

Layout.defaultProps = {
};

Layout.propTypes = {
};

export default Layout;
